import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global, BaoCao } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { LocalDataSource } from 'ng2-smart-table';
import { NumberViewComponent } from '../../../shared/components/public/numberview.component';
import { DateViewComponent } from '../../../shared/components/public/dateview.component';
import { FileRestrictions, SelectEvent, ClearEvent, RemoveEvent, FileInfo } from '@progress/kendo-angular-upload';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse, HttpEventType, HttpRequest } from '@angular/common/http';
import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import { DialogComponent, ButtonPropsModel } from '@syncfusion/ej2-angular-popups';
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');


@Component({
    selector: 'app-daotao-danhsachphatdungcuedit',
  templateUrl: './danhsachphatdungcuedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./danhsachphatdungcuedit.component.scss'],
    providers: [ListService, Repository]
})


export class danhsachphatdungcueditComponent implements OnInit {

  @ViewChild('ejskhoahoc') public ejskhoahoc: DialogComponent;

  hovaten: string = "";
  @ViewChild('myModal')
  myModal: BsModalComponent;
  @ViewChild('dteChung') doituongchungedit: any;

  @ViewChild('myModalNhieuSP')
  myModalNhieuSP: BsModalComponent;
  @ViewChild('dteNhieuSP') dteNhieuSP: any;

  // Add this property to the component class
  trangThaiPhat: string = ''; // '' = all, '1' = đã phát, '0' = chưa phát

  doituongkethua: any;
  doanhnghiepid: string = null;
  @Output() savect: EventEmitter<any> = new EventEmitter();
  datas: any;
  data: any;
  public dulieu: any = { dataGrid: null, dataGridTimKiem: null, datatieude: null, sobanghi: null };
  indLoading: boolean = false;
  dataFrm: FormGroup;
  modalTitle: string;
  modalBtnTitle: string;
  Id: string;
  NgayHienTai: Date = new Date();
  inputDonVi: any;
  public DonViDropId: any = { Id: null, Ten: null };
  public TaiKhoanDropId: any = { Id: null, Ten: null };
  TaiKhoanId: any;
  selecteddonvis: any;
  selectedchuongs: any;
  selectedkhoans: any;
  Ma_Tai_Khoan: any;
  dropdownList_DonVi = [];
  inputTaiKhoan: any;
  dropdownList_TaiKhoan = [];
  selectedItems = [];
  dropdownSettings = {};
  khoangthoigian: number = 0;
  tabselected: number = 1;
  inputthangs: any = [
    { text: "Hôm nay", value: 0 },
    { text: "Tháng 1", value: 1 },
    { text: "Tháng 2", value: 2 },
    { text: "Tháng 3", value: 3 },
    { text: "Tháng 4", value: 4 },
    { text: "Tháng 5", value: 5 },
    { text: "Tháng 6", value: 6 },
    { text: "Tháng 7", value: 7 },
    { text: "Tháng 8", value: 8 },
    { text: "Tháng 9", value: 9 },
    { text: "Tháng 10", value: 10 },
    { text: "Tháng 11", value: 11 },
    { text: "Tháng 12", value: 12 },
    { text: "Quý I", value: 13 },
    { text: "Quý II", value: 14 },
    { text: "Quý III", value: 15 },
    { text: "Quý IV", value: 16 },
    { text: "Tuần này", value: 17 },
    { text: "Tháng này", value: 18 },
    { text: "Năm nay", value: 19 },
    { text: "Đầu năm đến nay", value: 20 },
    { text: "Năm trước", value: 21 },

  ];

  public thangs: Array<{ text: string, value: number }> = [
    { text: "1", value: 1 },
    { text: "2", value: 2 },
    { text: "3", value: 3 },
    { text: "4", value: 4 },
    { text: "5", value: 5 },
    { text: "6", value: 6 },
    { text: "7", value: 7 },
    { text: "8", value: 8 },
    { text: "9", value: 9 },
    { text: "10", value: 10 },
    { text: "11", value: 11 },
    { text: "12", value: 12 }
  ];

  public quys: Array<{ text: string, value: number }> = [
    { text: "1", value: 1 },
    { text: "2", value: 2 },
    { text: "3", value: 3 },
    { text: "4", value: 4 },

  ];

  public nams: Array<{ text: string, value: number }> = [
    { text: (this.NgayHienTai.getFullYear() - 3).toString(), value: (this.NgayHienTai.getFullYear() - 3) },
    { text: (this.NgayHienTai.getFullYear() - 2).toString(), value: (this.NgayHienTai.getFullYear() - 2) },
    { text: (this.NgayHienTai.getFullYear() - 1).toString(), value: (this.NgayHienTai.getFullYear() - 1) },
    { text: this.NgayHienTai.getFullYear().toString(), value: this.NgayHienTai.getFullYear() },
    { text: (this.NgayHienTai.getFullYear() + 1).toString(), value: (this.NgayHienTai.getFullYear() + 1) },
    { text: (this.NgayHienTai.getFullYear() + 2).toString(), value: (this.NgayHienTai.getFullYear() + 2) },
    { text: (this.NgayHienTai.getFullYear() + 3).toString(), value: (this.NgayHienTai.getFullYear() + 3) },

  ];

  public chons: Array<{ text: string, value: number }> = [
    { text: "Theo ngày", value: 1 },
    { text: "Theo tháng", value: 2 },
    { text: "Theo quý", value: 3 },
    { text: "Theo năm", value: 4 },

  ];
  chongioitinhs: any = [{ Id: 0, Ma_Doi_Tuong: "0", Ten_Doi_Tuong: "Nữ" }
    , { Id: 1, Ma_Doi_Tuong: "1", Ten_Doi_Tuong: "Nam" }];
  TatCa: boolean = false;
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = 5;
  public TimKiem: string;
  public StartPage: number = 1;
  public EndPage: number = 20;
  public pageSize: number = 20;
  public pages: any;
  public totalPages: number;
  public TimKiems: any = {
    Don_Vi_Id: null
    , DonViId: null
    , DonVi2Id: null
    , Doanh_Nghiep_Id: null
    , UserName: null
    , Nam: null
    , NamSinh: null
    , TuNgay: null
    , DenNgay: null
    , Phan_He_Id: null
    , TimKiem: null
    , Loai: null
    , HeSo: null
    , startPage: null
    , endPage: null
    , NgayThuTien: null
    , Ngay: null
    , NgayS: null
    , Ma: null
    , Ten: null
    , MoTa: null
    , GhiChu: null
    , SapXep: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , LoaiS: null
    , DonViTinh: null
    , HangXe: null
    , ModelXe: null
    , GiaMua: null
    , MaKH: null
    , KhachHang: null
    , DienThoai: null
    , DiaChi: null
    , QuanLy: null
    , SoKhung: null
    , SoMay: null
    , KhoaHoc: null
    , TrangThaiS: null
    , HinhThucThanhToan: null
    , NguoiNhap: null
    , SoLuong: null
    , DonGia: null
    , NhaCungCap: null
    , KhoHang: null
    , CreatedBy: null
    , QuyenSo: null
    , SoPhieu: null
    , NguoiNhan: null
    , NhanSuId: null

  };
  public ngaytimkiem: Date = new Date();
  TichTatCa() {
    this.datas.forEach((item: any) => {
      item.Tich = !this.TatCa;
    });
  }
  onKeydownEvent(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search();
    }
  }

  public TuNgay: Date = new Date();
  public DenNgay: Date = new Date();
  public TuNgay1: Date = new Date();
  public DenNgay1: Date = new Date();
  public tTuNgay: string;
  public tDenNgay: string;

 

 
  idFocus: string = '00000000-0000-0000-0000-000000000000';

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
  public ngxAmOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: true
  };

  public currentUser;
  donviid: string = null;
  namketoan: number;
  username: string = null;
  nhomdoituongid: any;
  nhansuid: string;
  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private fb: FormBuilder, private _dataService: ListService, public repo: Repository) {



  }

  // @HostListener('document:keydown', ['$event'])
   public innerHeight: any
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
   loadDataInit(id: string, hovaten, pheid: string) {
    this.nhansuid = id;
    this.hovaten = hovaten;
    this.ngaytimkiem = null;
    this.StartPage = 1;
    this.EndPage = 20;
    this.ngaytimkiem = null;
    this.innerHeight = window.innerHeight - 250;
    this.nhomdoituongid = pheid;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.donviid = this.currentUser.id_don_vi;
      this.namketoan = this.currentUser.nam_ke_toan;
      this.username = this.currentUser.user_name;
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === this.nhomdoituongid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
       
      }
     
      
    }
    this.search();
        
    
  }

  


  
  //saveModal(id: any) {
  //  this.Loaddatas();
  //  this.modal.close();
  //}

  
  pageChanged(event: any): void {
    // alert(event.page);
    //console.log('a');
    //console.log(event);
    this.currentPage = event.page;
    this.Loaddatas();
  }
  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    this.Loaddatas();
  }
  public onBlur(): void {
    this.Loaddatas();
  }
  search() {
    this.currentPage = 1;
    this.pageSize = 50;
    this.Loaddatas();
  }
  search1() {
    this.Loaddatas();
  }
  Loaddatas(): void {
    this.datas = [];
    this.StartPage = (this.currentPage - 1) * this.pageSize + 1;
    this.EndPage = this.currentPage * this.pageSize;
    this.totalItems = 0;
    this.TimKiems.UserName = this.currentUser.user_name;
    this.TimKiems.DonVi2Id = this.currentUser.id_don_vi;
    this.TimKiems.Don_Vi_Id = this.currentUser.id_don_vi;
    this.TimKiems.Phan_He_Id = this.nhomdoituongid;
    this.TimKiems.HeSo = -1; // xuất kho
    this.TimKiems.NhanSuId = this.nhansuid;

    // Add filter for Đã phát/Chưa phát
    if (this.trangThaiPhat === '1') {
      this.TimKiems.TrangThai = 1; // Đã phát (ngày có giá trị)
    } else if (this.trangThaiPhat === '0') {
      this.TimKiems.TrangThai = 0; // Chưa phát (ngày rỗng)
    } else {
      this.TimKiems.TrangThai = null; // Tất cả
    }

    //this.TimKiems.Ma_DV = this.currentUser.ma_dv;
    this.TimKiems.startPage = this.StartPage;
    this.TimKiems.endPage = this.EndPage;
    if (this.ngaytimkiem != null) {
      this.TimKiems.ModifiedS = this.ngaytimkiem.getFullYear() + '-' + (this.ngaytimkiem.getMonth() + 1) + '-' + this.ngaytimkiem.getDate();
    }
    else
      this.TimKiems.ModifiedS = null;


    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiems)
    };
    $('#loading').show();
    this.repo.postRequest("api/quanlykho/get_listviewpage/", this.TimKiems)
      .subscribe(response => {
        $('#loading').hide();
        this.totalPages = 0;
        this.totalItems = 0;
        if (response.length > 0) {
          var item = response[0];
          this.totalItems = item["totalRows"];
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          let start, end;
          if (this.totalPages <= 5) {
            start = 1;
            end = this.totalPages;
          } else {
            if (this.currentPage <= 3) {
              start = 1;
              end = 5;
            } else if (this.currentPage + 1 >= this.totalPages) {
              start = this.totalPages - 4;
              end = this.totalPages;
            } else {
              start = this.currentPage - 2;
              end = this.currentPage + 2;
            }
          }
          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.pages = resultArray;
        }
        this.datas = response;
        (window as any).timer(0, 1000);
        //(window as any).timer(3, 1000);
      });


  }

  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
    } 
    this.LoadCategory();
  }

  LoadCategory(): void {

  }
  //----------event xử lý di chuyển Enter--------------------------------------
  tongtien: number = 0;
  maxcot: number = 13;

  
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Don_Vi.toLowerCase().indexOf(term) > -1 || item.Ten_Don_Vi.toLowerCase().indexOf(term) > -1;
  }
  rowSelected: any = null;
  comboSeleted: NgSelectComponent;

 
  

  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }

  adddata() {

    this.modalTitle = "Đăng ký mua dụng cụ học tập";
    this.modalBtnTitle = "Thêm";
    this.doituongchungedit.loadDataInit(this.nhomdoituongid, null, this.donviid, this.nhansuid, this.hovaten, 1);
    this.myModal.open();
  }
  //clonedata(row: any) {
  //  this.modalTitle = "Sao chép thông tin " + this.headerTitle;
  //  this.modalBtnTitle = "Cập nhật";
  //  this.doituongchungedit.loadDataInit(this.nhomdoituongid, null, this.donviid, row);
  //  this.myModal.open();
  //  // this.modal.show();
  //}

  editdata(row: any) {
    console.log(row);
    this.modalTitle = "Cập nhập thông tin dụng cụ học tập";
    this.modalBtnTitle = "Cập nhật";
    this.doituongchungedit.loadDataInit(this.nhomdoituongid, row.Id, this.donviid, this.nhansuid, this.hovaten, 1);
    this.myModal.open();
  }
  saveModal(id: any) {
    if (id != null)
      this.Loaddatas();
    this.myModal.close();
    this.myModalNhieuSP.close();
  }

  adddata_nhieu() {

    this.modalTitle = "Đăng ký nhiều dụng cụ học tập";
    this.modalBtnTitle = "Thêm";
    this.dteNhieuSP.loadDataInit(this.nhomdoituongid, null, this.donviid, this.nhansuid, this.hovaten, 1);
    this.myModalNhieuSP.open();
  }

  deletedata(id: string) {
    console.log(id);
    swal({
      title: 'Bạn muốn xóa bản ghi?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
          className: "bg-danger"
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-success",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {

          $('#loading').show();
          this.repo.postRequest('api/quanlykho/delete/', { IdGuid: id, PhanHeId: this.nhomdoituongid, UserName: this.currentUser.user_name }).subscribe(
            data => {
              $('#loading').hide();
              if (data == "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');

                this.Loaddatas();
              }
              else {
                // this.msg = data;
                swal('Cảnh báo!', data, 'warning');
              }


            },
            error => {
             
            }
          );
        }
      });


  }

  public export(kieuin) {

    let dsid = "";
    this.datas.forEach((item: any) => {
      if (item.Tich == true) {
        if (dsid == "")
          dsid = item.Id;
        else
          dsid = dsid + "," + item.Id;
      }
    });

    if (dsid == "") {
      swal('Cảnh báo!', 'Chưa chọn thông tin phát dụng cụ để in hóa đơn!.', 'error');
      return;
    }

    $('#loading').show();
    let data = {
      Id: "1C52B1F5-B560-455D-A528-1F113C2209DA",
      Type: kieuin,
      Data: JSON.stringify({ Id: dsid, UserName: this.currentUser.user_name, DonViId: this.currentUser.id_don_vi })
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {

              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'vnd.ms-excel' });
            var fileURL = URL.createObjectURL(file);
            var a = document.createElement("a");
            a.href = fileURL;
            let ngay = new Date();
            a.download = "hoa_don.xlsx";
            document.body.appendChild(a);
            a.click();
          }


        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {

              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }



  }

}
